export default __webpack_public_path__ + "static/media/melancholy_clip.db5b032c.mp3";